import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=d8909508&"
import script from "./Patient.vue?vue&type=script&lang=js&"
export * from "./Patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports